import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, PHONES } from "@/data";
import { Reveal, Eyebrow } from "./Reveal";

const Row = ({ s, i }) => (
  <Reveal delay={i * 0.08}>
    <a
      data-testid={`service-${s.title.toLowerCase()}`}
      href={`${PHONES[0].wa}?text=${encodeURIComponent(`Olá! Gostaria de marcar um serviço de ${s.title}.`)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="group grid grid-cols-12 items-center gap-4 border-t border-white/10 py-8 sm:py-12 transition-colors hover:border-[#d4af37]/60"
    >
      <span className="col-span-2 sm:col-span-1 font-serif text-xl text-[#d4af37]">{s.n}</span>
      <div className="col-span-10 sm:col-span-6">
        <h3 className="font-serif text-4xl sm:text-6xl transition-transform duration-500 group-hover:translate-x-3">{s.title}</h3>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-300 sm:text-base">{s.text}</p>
        <div className="mt-5 flex flex-wrap gap-2">
          {s.tags.map((t) => (
            <span key={t} className="rounded-full border border-white/15 px-3 py-1 text-xs text-zinc-300">{t}</span>
          ))}
        </div>
      </div>
      <div className="col-span-12 sm:col-span-4 overflow-hidden rounded-[4px]">
        <motion.img
          src={s.img}
          alt={s.title}
          loading="lazy"
          style={{ objectPosition: s.pos ?? "50% 50%" }}
          className="aspect-[16/10] w-full object-cover grayscale transition-[filter,transform] duration-700 group-hover:grayscale-0 group-hover:scale-105"
        />
      </div>
      <span className="hidden sm:flex col-span-1 justify-end">
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 transition-colors group-hover:bg-[#d4af37] group-hover:text-black">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </span>
    </a>
  </Reveal>
);

export const Services = () => (
  <section id="servicos" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
    <Reveal className="mb-16 grid gap-8 lg:grid-cols-2 lg:items-end">
      <div>
        <Eyebrow>Serviços</Eyebrow>
        <h2 className="mt-6 font-serif text-5xl leading-[1] sm:text-7xl">
          Cuidado ao <span className="gold-text italic">detalhe</span>
        </h2>
      </div>
      <p className="max-w-md text-base text-zinc-300 lg:justify-self-end">
        Três especialidades, a mesma dedicação. Toque num serviço para falar connosco pelo WhatsApp.
      </p>
    </Reveal>
    {SERVICES.map((s, i) => <Row key={s.n} s={s} i={i} />)}
    <div className="border-t border-white/10" />
  </section>
);
